import type { DataChartResult } from '../serviceExecutionApi';
import { ProcessedFilePreview } from './ProcessedFilePreview';

export function DataAnalysisChartsReview({ charts, preview }: {
  charts: DataChartResult[];
  preview?: { requestId: string; runId: string; role?: string };
}) {
  if (!charts.length) return null;
  return <section aria-label="Графики анализа">
    <h3>Графики</h3>
    <p>Перед утверждением проверьте подписи, масштаб и читаемость. PNG и SVG войдут в результат; изображения также включены в Word-отчёт.</p>
    {charts.map((chart, index) => <article key={chart.id}>
      <h4>График {index + 1}: {chart.config.kind === 'HISTOGRAM' ? 'распределение' : 'диаграмма рассеяния'} · {chart.config.x}{chart.config.y ? ` / ${chart.config.y}` : ''}</h4>
      <p>Полных наблюдений: {chart.included} · исключено: {chart.excluded_records.length}</p>
      {chart.reason ? <p role="status">{chart.reason}</p> : <ProcessedFilePreview preview={preview} file={{ id: chart.id, filename: `${chart.id}.png` }} disabled reviewable={false} onChange={() => undefined} />}
      {!!chart.excluded_records.length && <details><summary>Исключённые записи</summary><p>Номера строк исходной таблицы с учётом заголовка: {chart.excluded_records.join(', ')}</p></details>}
    </article>)}
  </section>;
}
